import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { StatusBar, Style } from "@capacitor/status-bar";
import { LiveUpdate as CapacitorLiveUpdate } from "@capawesome/capacitor-live-update";
import { captureMessage } from "~/config/sentry";
import { init as initBadge } from "./badge/index";

// Init for every environment, including "web"
async function commonInit() {
  return;
}

// Init for native platforms only (ios | android)
async function nativeInit() {
  if (Capacitor.isPluginAvailable("StatusBar")) {
    await StatusBar.setStyle({ style: Style.Light });
  }
  if (Capacitor.isPluginAvailable("App")) {
    window.appInfos = await App.getInfo();
  }
  await initBadge();

  // Capawesome LiveUpdate is used to update the app from the server url fro Capacitor app
  if (Capacitor.isPluginAvailable("LiveUpdate")) {
    const result = await CapacitorLiveUpdate.ready();
    if (result.currentBundleId) {
      const message = `🔷 The Capacitor app is now using the bundle with the identifier ${result.currentBundleId}.`;
      console.info(message);
      captureMessage(message);
    }
    if (result.previousBundleId) {
      const message = `🔷 The Capacitor app was using the bundle with the identifier ${result.previousBundleId}.`;
      console.info(message);
      captureMessage(message);
    }
    if (result.rollback) {
      const message = "🔷 The Capacitor app was reset to the default bundle.";
      console.info(message);
      captureMessage(message);
    }

    // const listener = await CapacitorLiveUpdate.addListener(
    //   "downloadBundleProgress",
    //   (downloadEvent) => {
    //     console.info("🔷 Capawesome LiveUpdate downloadEvent", downloadEvent);
    //     console.info("🔷 downloadEvent.progress", downloadEvent.progress);
    //   }
    // );

    // Add sync functionality to check for updates
    const sync = async () => {
      try {
        const syncResult = await CapacitorLiveUpdate.sync();
        console.info("🔷 syncResult", syncResult);
        if (syncResult.nextBundleId) {
          const message = `🔷 New bundle available: ${syncResult.nextBundleId}`;
          console.info(message);
          captureMessage(message);
          // Don't reload here - let the caller decide
          return syncResult; // Return the result
        }
        return syncResult;
      } catch (error) {
        const message = "🔷 Live Update sync failed";
        console.info(message, { extra: { error } });
        captureMessage(message, { extra: { error } });
        throw error; // Re-throw to let caller handle
      }
    };

    // Perform initial sync when app starts
    const syncResult = await sync();
    if (syncResult?.nextBundleId) {
      await CapacitorLiveUpdate.reload(); // ← RELOAD HERE
    }
    // void listener.remove();
  }
}

// Android specific init
async function androidInit() {
  return;
}

// Ios specific init
async function iOSInit() {
  if (Capacitor.isPluginAvailable("Keyboard")) {
    await Keyboard.setAccessoryBarVisible({ isVisible: true });
  }
}

async function platformSpecificInit() {
  const platform = Capacitor.getPlatform();
  const isNative = Capacitor.isNativePlatform();

  if (isNative) {
    await nativeInit();
  }
  if (platform === "ios") {
    await iOSInit();
  } else if (platform === "android") {
    await androidInit();
  }
}

async function initCapacitor() {
  await commonInit();
  await platformSpecificInit();
  console.info("Clovis capacitor config has been set");
  return null;
}

export { initCapacitor };
